import React, { useEffect, useState } from 'react';
import { InstagramIcon } from './icons/Icons';
import { Logo } from './Logo';
import { useLanguage } from '../LanguageContext';
type LegalModal = null | 'privacy' | 'terms';
export const Footer = () => {
  const [openModal, setOpenModal] = useState<LegalModal>(null);
  const {
    language
  } = useLanguage();
  const lastUpdated = language === 'es' ? 'Mayo 2026' : 'May 2026';
  useEffect(() => {
    if (openModal) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [openModal]);
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpenModal(null);
    };
    if (openModal) {
      window.addEventListener('keydown', handleKey);
      return () => window.removeEventListener('keydown', handleKey);
    }
  }, [openModal]);
  return <footer className="bg-brand-pink pt-10 pb-8 border-t border-brand-gold/10" data-id="element-89">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-90">
        <div className="flex flex-col items-center mb-8" data-id="element-91">
          <div className="mb-4" data-id="element-92">
            <Logo size="lg" data-id="element-93" />
          </div>

          <div className="flex items-center space-x-2 text-brand-bronze mb-5" data-id="element-94">
            <span className="text-sm" data-id="element-95">♡</span>
            <p className="text-sm md:text-base font-medium tracking-widest uppercase" data-id="element-96">
              {language === 'es' ? 'Tu bienestar es mi prioridad' : 'Your well-being is my priority'}
            </p>
            <span className="text-sm" data-id="element-97">♡</span>
          </div>

          <div className="flex space-x-6 mb-6" data-id="element-98">
            <a href="https://instagram.com/skinglowstudio22" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-brand-gold/30 flex items-center justify-center text-brand-charcoal hover:bg-brand-gold hover:text-white hover:border-brand-gold transition-all" aria-label="Instagram" data-id="element-99">
              <InstagramIcon size={18} data-id="element-100" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left border-t border-brand-gold/10 pt-6" data-id="element-101">
          <div data-id="element-102">
            <h4 className="text-sm font-medium text-brand-charcoal uppercase tracking-widest mb-4" data-id="element-103">
              {language === 'es' ? 'Contacto' : 'Contact'}
            </h4>
            <ul className="space-y-2 text-sm text-brand-charcoal/70" data-id="element-104">
              <li data-id="element-105">
                <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-106">
                  WhatsApp · 267-984-1013
                </a>
              </li>
              <li data-id="element-107">
                <a href="https://skinglowstudio22.com" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-108">
                  skinglowstudio22.com
                </a>
              </li>
              <li data-id="element-109">Philadelphia, PA</li>
            </ul>
          </div>

          <div data-id="element-110">
            <h4 className="text-sm font-medium text-brand-charcoal uppercase tracking-widest mb-4" data-id="element-111">
              {language === 'es' ? 'Navegación' : 'Navigation'}
            </h4>
            <ul className="space-y-2 text-sm text-brand-charcoal/70" data-id="element-112">
              <li data-id="element-113">
                <a href="#inicio" className="hover:text-brand-gold transition-colors" data-id="element-114">
                  {language === 'es' ? 'Inicio' : 'Home'}
                </a>
              </li>
              <li data-id="element-115">
                <a href="#sobre-mi" className="hover:text-brand-gold transition-colors" data-id="element-116">
                  {language === 'es' ? 'Sobre María Fernanda' : 'About María Fernanda'}
                </a>
              </li>
              <li data-id="element-117">
                <a href="#servicios" className="hover:text-brand-gold transition-colors" data-id="element-118">
                  {language === 'es' ? 'Servicios' : 'Services'}
                </a>
              </li>
              <li data-id="element-119">
                <a href="#testimonios" className="hover:text-brand-gold transition-colors" data-id="element-120">
                  {language === 'es' ? 'Testimonios' : 'Testimonials'}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-121">
            <p className="text-sm text-brand-charcoal/70 leading-relaxed" data-id="element-122">
              {language === 'es' ? <>
                  Atención personalizada.
                  <br data-id="element-123" />
                  Con cita previa únicamente.
                  <br data-id="element-124" />
                  Cupos limitados.
                </> : <>
                  Personalized attention.
                  <br data-id="element-125" />
                  By appointment only.
                  <br data-id="element-126" />
                  Limited spots.
                </>}
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-brand-gold/10 flex flex-col items-center gap-3" data-id="element-127">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-brand-charcoal/70" data-id="element-128">
            <button type="button" onClick={() => setOpenModal('privacy')} className="hover:text-brand-gold transition-colors underline-offset-4 hover:underline" data-id="element-129">
              Privacy Policy
            </button>
            <span className="text-brand-gold/40" data-id="element-130">•</span>
            <button type="button" onClick={() => setOpenModal('terms')} className="hover:text-brand-gold transition-colors underline-offset-4 hover:underline" data-id="element-131">
              Terms of Service
            </button>
          </div>
          <p className="text-xs text-brand-charcoal/50 text-center" data-id="element-132">
            &copy; {new Date().getFullYear()} Skin Glow Studio 22.{' '}
            {language === 'es' ? 'Todos los derechos reservados.' : 'All rights reserved.'}
          </p>
        </div>
      </div>

      {/* Legal Modal */}
      {openModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-133">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-brand-charcoal/60 backdrop-blur-sm animate-[fadeIn_.2s_ease-out]" onClick={() => setOpenModal(null)} data-id="element-134"></div>

          {/* Panel */}
          <div className="relative w-full max-w-2xl max-h-[85vh] bg-brand-cream rounded-2xl shadow-2xl border border-brand-gold/20 flex flex-col overflow-hidden" data-id="element-135">
            {/* Header */}
            <div className="flex items-start justify-between px-6 sm:px-8 pt-6 pb-4 border-b border-brand-gold/15" data-id="element-136">
              <div data-id="element-137">
                <div className="flex items-center space-x-3 mb-2" data-id="element-138">
                  <div className="h-px w-8 bg-brand-gold" data-id="element-139"></div>
                  <span className="text-[10px] tracking-[0.2em] font-medium text-brand-bronze uppercase" data-id="element-140">
                    Skin Glow Studio 22
                  </span>
                </div>
                <h3 id="legal-modal-title" className="text-2xl sm:text-3xl font-serif text-brand-charcoal" data-id="element-141">
                  {openModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
                </h3>
                <p className="text-xs text-brand-charcoal/60 mt-1" data-id="element-142">
                  {language === 'es' ? 'Última actualización:' : 'Last updated:'}{' '}
                  {lastUpdated}
                </p>
              </div>
              <button type="button" onClick={() => setOpenModal(null)} aria-label="Cerrar" className="text-brand-charcoal/60 hover:text-brand-gold transition-colors p-2 -mr-2 -mt-1" data-id="element-143">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-144">
                  <line x1="18" y1="6" x2="6" y2="18" data-id="element-145"></line>
                  <line x1="6" y1="6" x2="18" y2="18" data-id="element-146"></line>
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 sm:px-8 py-6 text-sm text-brand-charcoal/80 leading-relaxed space-y-5" data-id="element-147">
              {openModal === 'privacy' ? <PrivacyContent data-id="element-148" /> : <TermsContent data-id="element-149" />}
            </div>

            {/* Footer */}
            <div className="px-6 sm:px-8 py-4 border-t border-brand-gold/15 flex justify-end bg-brand-blush/40" data-id="element-150">
              <button type="button" onClick={() => setOpenModal(null)} className="px-6 py-2.5 bg-brand-gold text-white text-sm font-medium rounded-full hover:bg-brand-bronze transition-all shadow-sm" data-id="element-151">
                {language === 'es' ? 'Entendido' : 'Understood'}
              </button>
            </div>
          </div>
        </div>}
    </footer>;
};
const SectionHeading = ({
  children
}: {
  children: React.ReactNode;
}) => <h4 className="text-base font-serif text-brand-charcoal mt-2" data-id="element-152">{children}</h4>;
const PrivacyContent = () => <>
    <p data-id="element-153">
      En Skin Glow Studio 22 respetamos tu privacidad y nos comprometemos a
      proteger la información personal que compartes con nosotros. Esta política
      describe cómo recopilamos, usamos y protegemos tus datos.
    </p>

    <SectionHeading data-id="element-154">1. Información que recopilamos</SectionHeading>
    <p data-id="element-155">
      Recopilamos información que tú nos proporcionas directamente: nombre,
      teléfono, correo electrónico, y datos relevantes sobre tu piel o historial
      de tratamientos al momento de agendar una cita o realizar una consulta.
    </p>

    <SectionHeading data-id="element-156">2. Uso de la información</SectionHeading>
    <p data-id="element-157">
      Utilizamos tu información únicamente para: agendar y confirmar tus citas,
      personalizar tus tratamientos, enviarte recordatorios o información
      relevante sobre el cuidado de tu piel, y mejorar la calidad de nuestros
      servicios.
    </p>

    <SectionHeading data-id="element-158">3. Confidencialidad</SectionHeading>
    <p data-id="element-159">
      Toda la información compartida durante tu consulta y tratamiento es
      tratada con absoluta confidencialidad. No compartimos, vendemos ni
      alquilamos tus datos personales a terceros.
    </p>

    <SectionHeading data-id="element-160">4. Cookies y sitio web</SectionHeading>
    <p data-id="element-161">
      Este sitio web puede utilizar cookies básicas para mejorar tu experiencia
      de navegación. Puedes desactivarlas desde la configuración de tu
      navegador.
    </p>

    <SectionHeading data-id="element-162">5. Tus derechos</SectionHeading>
    <p data-id="element-163">
      En cualquier momento puedes solicitar acceso, corrección o eliminación de
      tus datos personales contactándonos al 267-984-1013.
    </p>

    <SectionHeading data-id="element-164">6. Contacto</SectionHeading>
    <p data-id="element-165">
      Si tienes alguna pregunta sobre esta política, escríbenos a través de
      nuestro Instagram{' '}
      <a href="https://instagram.com/skinglowstudio22" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:underline" data-id="element-166">
        @skinglowstudio22
      </a>{' '}
      o llámanos al 267-984-1013.
    </p>
  </>;
const TermsContent = () => <>
    <p data-id="element-167">
      Al agendar una cita o utilizar los servicios de Skin Glow Studio 22,
      aceptas los siguientes términos y condiciones. Te pedimos leerlos con
      atención.
    </p>

    <SectionHeading data-id="element-168">1. Citas y reservas</SectionHeading>
    <p data-id="element-169">
      Todas las citas se realizan únicamente con reserva previa. Te pedimos
      llegar puntualmente; en caso de retraso superior a 15 minutos, la cita
      puede ser reprogramada para no afectar a otros clientes.
    </p>

    <SectionHeading data-id="element-170">2. Cancelaciones</SectionHeading>
    <p data-id="element-171">
      Las cancelaciones deben hacerse con al menos 24 horas de anticipación.
      Cancelaciones tardías o ausencias sin aviso pueden requerir un depósito
      para futuras citas.
    </p>

    <SectionHeading data-id="element-172">3. Tratamientos y consultas</SectionHeading>
    <p data-id="element-173">
      Cada tratamiento es personalizado de acuerdo a tu tipo de piel y
      necesidades. Es responsabilidad del cliente informar de manera completa y
      veraz sobre alergias, medicamentos, embarazo o cualquier condición médica
      relevante antes del tratamiento.
    </p>

    <SectionHeading data-id="element-174">4. Resultados</SectionHeading>
    <p data-id="element-175">
      Los resultados de cualquier tratamiento estético pueden variar según la
      piel, el cuidado posterior y los hábitos de cada persona. No garantizamos
      resultados idénticos para todos los clientes.
    </p>

    <SectionHeading data-id="element-176">5. Pagos</SectionHeading>
    <p data-id="element-177">
      Los pagos se realizan al finalizar cada servicio, salvo paquetes o
      promociones que requieran depósito previo. Los precios pueden cambiar sin
      previo aviso.
    </p>

    <SectionHeading data-id="element-178">6. Conducta y respeto</SectionHeading>
    <p data-id="element-179">
      Skin Glow Studio 22 es un espacio de bienestar. Nos reservamos el derecho
      de admisión y de finalizar cualquier servicio en caso de comportamiento
      irrespetuoso.
    </p>

    <SectionHeading data-id="element-180">7. Modificaciones</SectionHeading>
    <p data-id="element-181">
      Estos términos pueden actualizarse periódicamente. La versión vigente
      siempre estará disponible en este sitio web con su fecha de última
      actualización.
    </p>
  </>;